import { useNavigate, useLocation } from "react-router-dom";

export default function ScrollLink({ to, hash, children, className, onClick, style }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();

    // Llamar al onClick si existe (para cerrar el menú móvil)
    if (onClick) onClick();

    if (location.pathname !== to) {
      // Primero navega a la ruta
      navigate(to);
      // Luego hace scroll al id
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      // Ya estamos en la ruta → solo scroll
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <a href={`#${hash}`} className={className} style={style} onClick={handleClick}>
      {children}
    </a>
  );
}
